import type { FaireProductEntity } from "../../entity_types/product";

export const p_zw6ga6sqfc: FaireProductEntity = {
  token: "p_zw6ga6sqfc",
  type: "product",
  name: "In the Lord's Army Kids Hoodie *NOTE SOME SIZES PREORDER*",
  brandToken: "b_fnw2e7p4xp",
  brandName: "BRVE by Fletch",
  imageUrl: "https://cdn.faire.com/fastly/70ef1672db15431308d8abf3576ca38ad67028e3c6d77e0db5eb50a48e3860d8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c42d5afc57bba84fcc2c2ad10dc80c7402e2067c6e0b906ea062cb0c32b06edd.jpeg",
    "https://cdn.faire.com/fastly/435452665e8a30f931201a9bb16e2370a10c931269915bf514570bd9a7b62561.jpeg",
    "https://cdn.faire.com/fastly/1c391e8f36d206e722c1b6820db7fbc937a76a3dc1dd1649b9cdc298ed80b344.png",
    "https://cdn.faire.com/fastly/c75b2b4bb5e86a53a07cf0037ab730f1522aa11b3e27f5dbaf14edb26233821d.jpeg",
    "https://cdn.faire.com/fastly/1f2ea9a69a0f66692e7d47a84439cbc70cf7c47f2942729ffda8343e5da08650.jpeg",
    "https://cdn.faire.com/fastly/e02995854c12ddced01ab8f07662af0470624556d29610c99f48f6d651471024.jpeg",
    "https://cdn.faire.com/fastly/a64773aa91cd40aa2befb87f4c4727ea6e3777dd037091d65617e15e1da55fb4.jpeg",
    "https://cdn.faire.com/fastly/43db57cf306e8e1ab5b0778591607b3eecc37c3bef313a3781650646ece6c360.jpeg",
    "https://cdn.faire.com/fastly/99d5d3d3e82b1294dc4958cf595809c7c0fadea9a5ba162a3e40341d2d6bd6b2.jpeg",
    "https://cdn.faire.com/fastly/441948695cb460d658d783e2db5a560082367dd8d842d492742d66df3225b9e8.jpeg",
    "https://cdn.faire.com/fastly/95c81c193c176b139db33634c2888d52af612d19f58d1637418ccb11e5e287f1.jpeg"
  ],
  priceDollars: 22.8,
  description: "\n\nWrap your little one in comfort and purpose with the BRVE Hoodie — designed for everyday wear and eternal reminders. This isn’t just another hoodie; it’s a statement of identity and courage.\n\n✨ Fabric You’ll Love:\nMade from a premium blend of 70% bamboo, 25% cotton, and 5% spandex, this hoodie is buttery-soft, breathable, and flexible — perfect for play, school, or cozy nights in.\n\n✨ Designed with Purpose:\nMarked with the BRVE logo, each hoodie is a reminder that our kids are called to be bold, rooted in truth, and shining God’s light in their world.\n\n✨ Made for Everyday:\nDurable, versatile, and designed for movement — this hoodie goes where your kids go, turning ordinary routines into opportunities to live brave.\n\nWith BRVE, your kids aren’t just wearing clothes — they’re carrying a mission.\n",
  tags: [],
  msrpDollars: 38,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:40.472Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
